module.exports = __webpack_public_path__ + "static/media/Portrait-10248.cec58022.jpg";